module.exports = __webpack_public_path__ + "img/Orbiting-Inspect-Portrait.6650db68.png";